/**
 * Timestamps for the launched GT workspace: absolute, with the viewer's time
 * zone named, plus an optional relative age (AC-14). Never "just now" alone —
 * a cached snapshot has to say exactly when it was read.
 */
export function formatGtTimestamp(iso, { timeZone } = {}) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
    timeZoneName: 'short', ...(timeZone ? { timeZone } : {}),
  }).format(date);
}

export function relativeAge(iso, now = Date.now()) {
  if (!iso) return '';
  const ms = now - new Date(iso).getTime();
  if (!Number.isFinite(ms)) return '';
  const minutes = Math.round(ms / 60000);
  if (minutes < 1) return 'less than a minute ago';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  const days = Math.round(hours / 24);
  return `${days} days ago`;
}
